import styled from "styled-components";
import { Link } from "react-router-dom";

export const LogoLinkContainer = styled(Link)`
  display: inline-block;
  text-decoration: none;
  padding: 0.55rem 0;
`;

export const LogoImg = styled.img`
  display: block;
  max-width: 100%;
`;
